import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './styles/Header.css';
import logo from '../assets/IMG_1008.PNG';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  // Off the home route there is no Hero behind the navbar — keep the solid look from the start.
  const [isScrolled, setIsScrolled] = useState(!isHome);

  useEffect(() => {
    if (!isHome) {
      setIsScrolled(true);
      return undefined;
    }

    const handleScroll = () => {
      const sections = ['home', 'about', 'classes', 'gallery', 'student-zone', 'contact'];
      const scrollPosition = window.scrollY + 100;

      // Shrink header + change background when user scrolls
      if (window.scrollY > 550) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      // Active section logic
      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  const scrollToSection = (sectionId) => {
    // From any non-home route, route back to "/" with a hash so we land on the right section.
    if (!isHome) {
      navigate(`/#${sectionId}`);
      setIsMenuOpen(false);
      return;
    }

    const section = document.getElementById(sectionId);
    if (section) {
      // This offset assumes the smaller (scrolled) header height
      const offsetTop = section.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header>
      {/* 'scrolled' controls both background, shadow, padding, and logo size */}
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-brand">
          <img
            src={logo}
            alt="Kalavaanya Logo"
            className="logo"
          />
        </div>

        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <a
              href="#home"
              className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
              onClick={() => scrollToSection('home')}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#about"
              className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
              onClick={() => scrollToSection('about')}
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#classes"
              className={`nav-link ${activeSection === 'classes' ? 'active' : ''}`}
              onClick={() => scrollToSection('classes')}
            >
              Classes
            </a>
          </li>
          {/* <li>
            <a
              href="#gallery"
              className={`nav-link ${activeSection === 'gallery' ? 'active' : ''}`}
              onClick={() => scrollToSection('gallery')}
            >
              Gallery
            </a>
          </li> */}
          <li>
            <a
              href="#student-zone"
              className={`nav-link ${activeSection === 'student-zone' ? 'active' : ''}`}
              onClick={() => scrollToSection('student-zone')}
            >
              Student Zone
            </a>
          </li>
          <li>
            <a
              href="#contact"
              className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
              onClick={() => scrollToSection('contact')}
            >
              Contact
            </a>
          </li>
        </ul>

        <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
    </header>
  );
};

export default Header;
